import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{class:{ clientcabin: _vm.isClientCabin },attrs:{"fluid":""}},[_c(VRow,{attrs:{"justify":"center"}},[(_vm.isClientCabin)?_c(VCol,{attrs:{"cols":"12","lg":"9","xl":"7"}},[_c('terms-of-service')],1):_c(VCol,[_c('terms-of-service')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }